<template>
<div>
    <h2>Recetas</h2>
    <br/>
      <b-nav vertical class="w-25" align-h="start">
        <b-nav-item active>Lista de recetas</b-nav-item>
        <b-nav-item>Nuevo informe</b-nav-item>
        <b-nav-item>Nueva receta</b-nav-item>
      </b-nav>
</div>
</template>


<script>
import { BIcon, BIconStarFill, BIconStar, BIconStarHalf, BSidebar, BButton, BNavbar, BNavbarToggle, BCollapse, BNavbarNav, BDropdownItem, BNavItemDropdown, BNavItem } from 'bootstrap-vue'
export default {
  name: 'sideBar',
  components: {
    BIcon,
    BIconStarFill,
    BIconStar,
    BIconStarHalf,
    BButton,
    BSidebar,
    BCollapse,
    BNavbarNav,
    BDropdownItem,
    BNavItemDropdown,
    BNavItem,
    BNavbar,
    BNavbarToggle
  },
  props: {
  }
}
</script>

<style lang="less">

.nav-item {
  list-style: none;
  text-align: left;
}

.nav-item, a {
  text-align: left;
}

</style>




// WEBPACK FOOTER //
// src/components/webapp/professional/sideBar.vue